<template>
    <div class="position-relative bg-white p-3 my-3 shadow-sm">
        
        <OverlaySpinner 
            v-if="$loading()"
            :showStatusText="true" 
            :statusText="$loadingStatus()"
        />

        <h1>{{ $i18n('LABEL_MAPS') }}</h1>

        <Alerts />

        <router-view />

    </div>
</template>

<script>
import Alerts from '../components/Alerts.vue';
import OverlaySpinner from '../components/OverlaySpinner.vue';

export default {
    name: 'Maps',
    components: {
        Alerts,
        OverlaySpinner
    },
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>

<style scoped>

</style>